<template>
  <div class="email-body">
    <nav class="mail-nav detail">
      <a href="./">首页</a> /
      <a href="./mailbox">收件箱</a> /
      <span>邮件详情</span>
    </nav>

    <div class="mail-content" v-if="!editmode">
      <div class="mail-header">
        <div class="btns">
          <v-btn @click="reply" variant="flat" color="primary">回复</v-btn>
          <v-btn @click="forward" variant="outlined">转发</v-btn>
          <v-btn @click="deleteEmails" variant="outlined">删除</v-btn>
          <v-btn @click="permanentlyDelete" variant="outlined">彻底删除</v-btn>
          <v-btn @click="back" variant="outlined">返回</v-btn>
        </div>
      </div>

      <div class="line"></div>

    </div>

    <div class="mail-edit" v-else>
      <div class="mail-edit-header">
        <label><span class="h">收件人:</span><input type="text" /> </label>
        <label><span class="h">主题:</span><input type="text" /> </label>
      </div>

      <div class="line"></div>

      <QuillEditor v-model:content="content" />

      <div class="mail-edit-footer">
        <v-btn @click="cancelEdit" variant="outlined">取消</v-btn>
        <v-btn @click="submit" variant="flat" color="primary">发送</v-btn>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

const router = useRouter()

const editmode = ref(false);
const content = ref('');

function reply() {
  editmode.value = true;
  console.log('reply');
}

function cancelEdit() {
  editmode.value = false;
}

function submit() {
  console.log('save');
}

function forward() {
  console.log('forward');
}

function deleteEmails() {
  console.log('deleteEmails');
}

function permanentlyDelete() {
  console.log('permanentlyDelete');
}

function back() {
  router.back();
}
</script>

<style>
@import '../assets/styles/email.css';
</style>
